import type { DropdownItem, NightCount } from "@search/api/types";
import NumberFilter from "@search/store/filters/primitive/NumberFilter";
import pluralize from "pluralize";

const defaultOption: DropdownItem = Object.freeze({
  value: -999,
  label: "Any nights",
});

class NightFilter extends NumberFilter {
  constructor(value: number) {
    super({
      defaultValue: defaultOption.value,
      label: "night",
      name: "nights",
      value,
    });
  }

  options(nights: Array<NightCount> = []) {
    const list = nights.map((item) => {
      const { nights } = item;
      const label = `${nights}${item.isPlus ? "+" : ""} ${pluralize("night", nights, false)} (${item.count})`;

      return { label, value: nights } as DropdownItem;
    });

    if (list.length > 0) {
      list.unshift(defaultOption);
    }

    return list;
  }
}

export default NightFilter;
export { NightFilter };
